import React, { useState } from "react";
import ReactCrop from "react-image-crop";
import { cropperFixer } from "../../utils/fixers";
import "react-image-crop/dist/ReactCrop.css";

const ImageCropper = ({ image, setFileInput, setImage }) => {
  const [crop, setCrop] = useState(cropperFixer);
  const [croppedImage, cropImage] = useState(null);
  const [image2, setImage2] = useState(null);

  const resetFileInput = (only) => {
    if (only) setImage(null);
    setFileInput(false);

    setTimeout(() => {
      setFileInput(true);
    }, 200);
  };

  const handleCropImage = (img = image2) => {
    const canvas = document.createElement("canvas");
    const scaleX = img.naturalWidth / img.width;
    const scaleY = img.naturalHeight / img.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    const pixelRatio = window.devicePixelRatio;
    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      img,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    const base64Image = canvas.toDataURL("image/jpeg");
    cropImage(base64Image);
  };

  return (
    <div className="crop-container" style={{ maxHeight: "100%" }}>
      <ReactCrop
        aspect={1}
        crop={crop}
        keepSelection={true}
        onChange={(c) => setCrop(c)}
        onDragEnd={() => handleCropImage()}
        // locked={true}
      >
        <img
          src={image}
          alt="crop"
          onLoad={({ target }) => {
            setImage2(target);
            handleCropImage(target);
          }}
        />
      </ReactCrop>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <button
          className="newBtn"
          style={{ marginTop: 20 }}
          type="button"
          onClick={resetFileInput}
        >
          Cancel
        </button>

        <button
          className="newBtn"
          style={{ marginTop: 20 }}
          type="button"
          onClick={() => {
            setImage(croppedImage);
            resetFileInput(true);
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default ImageCropper;
